<template>

  <div class="conversation-options dropdown">
    <button
      type="button"
      class="btn btn-outline-secondary"
      :disabled="saving"
      :title="$t('More')"
      @click="toggle">
      <i
        v-if="saving"
        class="fa-solid fa-circle-notch fa-spin"></i>
      <i
        v-else
        class="fa-solid fa-ellipsis-vertical"></i>
    </button>

    <div
      v-if="open"
      class="dropdown-menu dropdown-menu-right show options-menu">
      <!-- only worth showing while a candidate is associated -->
      <a
        v-if="canUnlink"
        href="javascript:void(0)"
        class="dropdown-item"
        @click="choose('unlink')">
        <i class="fa-solid fa-link-slash mr-2"></i>{{ $t('Unlink candidate') }}
      </a>
      <div
        v-if="canUnlink"
        class="dropdown-divider"></div>
      <a
        href="javascript:void(0)"
        class="dropdown-item text-danger"
        @click="choose('remove')">
        <i class="fa-solid fa-trash mr-2"></i>{{ $t('Remove conversation') }}
      </a>
    </div>

    <div
      v-if="open"
      class="options-backdrop"
      @click="close"></div>

  </div>

</template>

<script>
export default {
  name: 'ConversationOptions',
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    canUnlink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    close () {
      this.open = false
    },
    choose (action) {
      this.close()
      this.$emit(action)
    }
  }
}
</script>

<style scoped>
/* the .dropdown class already handles positioning; these only keep the menu
   above the backdrop that closes it on outside click */
.options-menu {
  display: block;
  min-width: 200px;
  z-index: 1050;
}

.options-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/conversation/ConversationOptions.vue